import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deleteAppAdminTrainingTopicSlice = createApi(`DeleteAppAdminTrainingTopicSlice`, "DELETE");

const DeleteAppAdminTrainingTopicSlice = createSlice({
  name: 'DeleteAppAdminTrainingTopicSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteAppAdminTrainingTopicSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAppAdminTrainingTopicSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deleteAppAdminTrainingTopicSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default DeleteAppAdminTrainingTopicSlice.reducer;
